import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';

/**
 * Login panel — replaces EditorPanel in the left column.
 * Same .editor-panel container + .field-container styling.
 */
export function LoginPanel({ onBack, onSwitchToSignup, onSwitchToClerk, onSuccess }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsSubmitting(true);

    const result = await login(email, password);
    setIsSubmitting(false);

    if (result.success) {
      onSuccess?.();
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="editor-panel max-h-full overflow-y-auto scrollbar-thin">
      {/* Header */}
      <div className="flex items-center justify-between gap-3">
        <div>
          <div className="text-sm font-semibold text-white/90">Log In</div>
          <div className="mt-1 text-xs text-white/55">
            Sign in to access your carousels.
          </div>
        </div>
        <button onClick={onBack} className="btn-control text-xs">
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
          </svg>
          Back
        </button>
      </div>

      {/* Form */}
      <form onSubmit={handleSubmit} className="mt-5 space-y-4">
        {error && (
          <div className="px-4 py-3 rounded-xl bg-red-500/10 border border-red-500/20 text-red-300 text-xs">
            {error}
          </div>
        )}

        <div className="field-container">
          <label className="block text-xs font-semibold text-white/85 mb-2">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input-base"
            placeholder="you@example.com"
            required
            autoFocus
          />
        </div>

        <div className="field-container">
          <label className="block text-xs font-semibold text-white/85 mb-2">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="input-base"
            placeholder="Enter your password"
            required
            minLength={4}
          />
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full py-3 rounded-xl bg-emerald-600 hover:bg-emerald-500 disabled:opacity-50 disabled:cursor-not-allowed text-white text-sm font-semibold transition-colors"
        >
          {isSubmitting ? (
            <span className="flex items-center justify-center gap-2">
              <div className="animate-spin h-4 w-4 border-2 border-white/30 border-t-white rounded-full" />
              Signing in...
            </span>
          ) : (
            'Sign In'
          )}
        </button>

        <div className="text-center text-xs text-white/50">
          Don't have an account?{' '}
          <button
            type="button"
            onClick={onSwitchToSignup}
            className="text-emerald-400 hover:text-emerald-300 transition-colors"
          >
            Sign up
          </button>
        </div>

        {/* Step 4: Link to Clerk email-code login when enabled */}
        {onSwitchToClerk && (
          <div className="text-center text-xs text-white/50 mt-2">
            Or{' '}
            <button
              type="button"
              onClick={onSwitchToClerk}
              className="text-emerald-400 hover:text-emerald-300 transition-colors"
            >
              continue with email code
            </button>
          </div>
        )}
      </form>
    </div>
  );
}
